import {
  LOAD_SUCCESS_COMPTES,
  LOAD_FAIL_COMPTES,
  SAVE_SUCCESS_COMPTES,
  SAVE_FAIL_COMPTES,
  UPDATE_SUCCESS_COMPTES,
  UPDATE_FAIL_COMPTES,
  DELETE_SUCCESS_COMPTES,
  DELETE_FAIL_COMPTES, LOAD_COMPTES,
} from "../actions/compteAction";


const initialState = { loaded: false, loading: true, };

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_COMPTES:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    case LOAD_SUCCESS_COMPTES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_COMPTES:
      return {
        ...state,
        loading: true,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_COMPTES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_COMPTES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_COMPTES:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.compte_id === action.payload.compte_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_COMPTES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_COMPTES:
      const filtered = state.data.filter((item) => {
        return item.compte_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_COMPTES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
